export default __webpack_public_path__ + "static/media/banner.09820b72.svg";